'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import {
  Auth,
  getLoggedUser
} from '@/_services/amplify.service.js'
import { organizationService } from '@/_services'
import createLogger from 'vuex/dist/logger'
import generalApp from './modules/generalApp/index'
import loader from './modules/loader/index'
import companies from './modules/companies/index'
import locations from './modules/locations/index'
import contacts from './modules/contacts/index'
import orders from './modules/orders/index'
import shipments from './modules/shipments/index'
import vehicles from './modules/vehicles/index'
import attachCognitoModule from '@vuetify/vuex-cognito-module'
import notifications from './modules/notifications/index'
import planner from './modules/planner/index'
import drops from './modules/drops/index'
import resources from './modules/resources/index'
import filters from './modules/filters'
import organizations_old from './modules/organizations_old'
import transports from './modules/transports'
import quoting from './modules/quoting'
import { exportData } from './modules/exports'
import { shipmentsGroupByDay } from './modules/shipments-groupbyday'
import { shipmentsContext } from './modules/shipments-context'
import { wrldUser } from './modules/wrld-user'
import { shipmentsMap } from './modules/shipments-map'
import { refinementListFilters } from './modules/refinement-list-filters'
import { numericsFilters } from './modules/numerics-filters'
import { rangesFilters } from './modules/ranges-filters'
import { attachments } from './modules/attachments'
import { uploads } from './modules/uploads'
import { shipmentsSchedule } from './modules/shipments-schedule'
import { organizations } from './modules/organizations'
import { pagination } from './modules/pagination'
import { queryFilters } from './modules/query-filters'



import {
  companyService
} from '@/_services'

Vue.use(Vuex)

Vue.config.debug = true
const debug = process.env.NODE_ENV !== 'production'

const initialState = {
  isReady: false,
  signedInCompany: {},
  signedInOrganization: {},
  loggedInUser: {}
}

const store = new Vuex.Store({
  state: {
    isReady: false,
    signedInCompany: {},
    signedInOrganization: {},
    loggedInUser: {}
  },
  actions: {
    setLogOutUser: ({
      commit
    }, action) => {
      commit('cognito/setUser', {})
      commit('logOutUser')
      Auth.signOut()
        .then(result => {
          commit('cognito/setUser', {})
        })
        .catch((error) => {
          console.error(error)
        })
      if (localStorage) localStorage.removeItem('USER')
    },
    setLoggedInUser: ({
      commit
    }) => {
      var user = null
      getLoggedUser().then((response) => {
        user = response.user
        return organizationService.getOrganization({ organizationID: user.org })
      }).then((organization) => {
        commit('setSignedInOrganization', {
          organization
        })
        commit('setLoggedInUser', {
          loggedInUser: user
        })
      })
    },
    resetState: ({ dispatch, commit }) => {
      dispatch('shipmentsContext/setResetState', { root: true })
      dispatch('shipmentsGroupByDay/setResetState', { root: true })
      dispatch('shipmentsMap/setResetState', { root: true })
      // commit('setSignedInResetState')
    }
  },
  mutations: {
    setIsReady: (store, payload) => (store['isReady'] = payload),
    setSignedInCompany(store, data) {
      if (data.id) {
        Vue.set(store.signedInCompany, 'id', data.id)
      }
      if (data.name) {
        Vue.set(store.signedInCompany, 'name', data.name)
      }
    },
    setLoggedInUser(store, action) {
      store.loggedInUser = {
        ...store.loggedInUser,
        ...action.loggedInUser
      }
    },
    setSignedInOrganization(store, action) {
      store.signedInOrganization = { ...action.organization }
    },
    logOutUser(store, action) {
      store.loggedInUser = {}
    },
    setSignedInResetState(store) {
      Object.assign(store, initialState)
    }
  },
  getters: {
    getLoggedInUserOrganization: (state) => {
      return state.cognito.session.idToken
    },
    getSignedInOrganization: (state) => {
      return state.signedInOrganization
    },
    getLoggedInUserOrganizationID: (state) => {
      return state.loggedInUser.org
    },
    getLoggedInUserRole: (state) => {
      return state.loggedInUser['cognito:groups'] != null ? state.loggedInUser['cognito:groups'][0] : null
    }
  },
  modules: {
    generalApp,
    loader,
    companies,
    locations,
    contacts,
    orders,
    shipments,
    vehicles,
    notifications,
    planner,
    drops,
    resources,
    filters,
    organizations,
    organizations_old,
    transports,
    quoting,
    exportData,
    shipmentsGroupByDay,
    shipmentsContext,
    shipmentsMap,
    shipmentsSchedule,
    wrldUser,
    queryFilters,
    refinementListFilters,
    numericsFilters,
    rangesFilters,
    pagination,
    attachments,
    uploads
  },
  strict: false,
  middlewares: debug ? [createLogger()] : []
})
attachCognitoModule(store, {
  userPoolId: 'eu-west-1_TCDg9Hy3A',
  userPoolWebClientId: '3e4e53q4ll18rid1dkp044i1d7',
  region: 'eu-west-1',
  authenticationFlowType: 'USER_PASSWORD_AUTH'
}, 'cognito')

// set LoggedIn User Information
store.dispatch('setLoggedInUser')
store.dispatch('wrldUser/initWrldUser')
store.dispatch('cognito/fetchSession')
  .then((response) => {})
  .catch((e) => {})
  .finally(() => {
    store.commit('setIsReady', true)
    if (store.state.cognito.user.attributes !== undefined) {
      store.commit('setSignedInCompany', {
        id: store.state.cognito.user.attributes['custom:company']
      })
    }
  })

export default store
